import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function Settings() {
  const { user } = useAuth();
  const [m, setM] = useState(null);
  const [email, setEmail] = useState("");
  const [savedEmail, setSavedEmail] = useState("");
  const [saving, setSaving] = useState(false);
  useEffect(() => {
    api.get("/admin/metrics").then((r) => setM(r.data));
    api.get("/admin/settings").then((r) => { setEmail(r.data.notification_email || ""); setSavedEmail(r.data.notification_email || ""); });
  }, []);

  const saveEmail = async () => {
    setSaving(true);
    try {
      const { data } = await api.put("/admin/settings", { notification_email: email });
      setSavedEmail(data.notification_email || "");
      toast.success("Notification email updated");
    } catch (e) { toast.error("Could not save"); }
    finally { setSaving(false); }
  };

  return (
    <div data-testid="admin-settings" className="max-w-3xl">
      <div className="mb-8">
        <p className="text-[11px] tracking-[0.3em] uppercase text-gold">Configuration</p>
        <h1 className="mt-3 font-serif font-light text-4xl text-ivory">Settings</h1>
      </div>

      <div className="space-y-6">
        <div className="border border-ivory/10 bg-navy-800 p-6">
          <h2 className="text-[11px] tracking-[0.25em] uppercase text-gold mb-4">Account</h2>
          <p className="text-ivory/70 text-sm">Signed in as <span className="text-ivory">{user?.email}</span></p>
          <p className="text-ivory/40 text-xs mt-2">Role: {user?.role || "admin"}</p>
        </div>

        <div className="border border-ivory/10 bg-navy-800 p-6">
          <h2 className="text-[11px] tracking-[0.25em] uppercase text-gold mb-4">The Founding Collection</h2>
          <p className="font-serif text-3xl text-ivory">
            {m?.founding_closed ? <span className="text-gold">Closed</span> : <><span className="text-gold">{m?.founding_members ?? 0}</span> <span className="text-ivory/40">/ {m?.founding_target ?? 20}</span></>}
          </p>
          <p className="text-ivory/40 text-xs mt-3">The Founding Collection is limited to 20 properties. Once reached, the public site displays “Founding Collection Closed”.</p>
        </div>

        <div className="border border-ivory/10 bg-navy-800 p-6">
          <h2 className="text-[11px] tracking-[0.25em] uppercase text-gold mb-4">Business Rules</h2>
          <ul className="text-ivory/60 text-sm space-y-2 list-none">
            {["Invitation does not equal acceptance.", "Application does not equal acceptance.", "Every property is individually reviewed.", "Every selected property is approved by an admin.", "The numerical score is internal only.", "Minimum target score is 85/100.", "Any non-negotiable failure can cause rejection.", "Founding Collection is limited to 20 properties."].map((r) => (
              <li key={r} className="flex gap-3"><span className="text-gold">·</span>{r}</li>
            ))}
          </ul>
        </div>

        <div className="border border-ivory/10 bg-navy-800 p-6" data-testid="notification-settings">
          <h2 className="text-[11px] tracking-[0.25em] uppercase text-gold mb-4">New-Application Alerts</h2>
          <p className="text-ivory/60 text-sm mb-4">The inbox that receives an email whenever a new property applies.</p>
          <div className="flex flex-col sm:flex-row gap-3">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="selection@yourdomain.com"
              data-testid="notification-email-input"
              className="flex-1 bg-navy-900 border border-ivory/15 focus:border-gold outline-none px-4 py-3 text-ivory text-sm transition-colors"
            />
            <button onClick={saveEmail} disabled={saving || email === savedEmail} data-testid="save-notification-email" className="bg-ivory hover:bg-gold text-navy px-8 py-3 text-[11px] tracking-[0.2em] uppercase transition-colors disabled:opacity-40">
              {saving ? "Saving" : "Save"}
            </button>
          </div>
          <p className="text-ivory/35 text-xs mt-3">Currently sending to: <span className="text-ivory/70">{savedEmail || "—"}</span></p>
        </div>
      </div>
    </div>
  );
}
